import { makeTaskQueueWithAtom } from "$root/utils";

/**
 * The save queue behind the instrument-customisation grid, and the state its `Saving…` / `Saved at …`
 * indicator reads.
 *
 * Deliberately a module singleton rather than a hook: a cell commit fires an HTTP `PATCH` that keeps
 * running when the user navigates away, so the queue must survive the unmount. A per-mount queue
 * would (a) break the sequencing the queue exists for — the fresh queue knows nothing about the tasks
 * the previous one still has in flight and would run its own `PATCH`es alongside them — and (b) leave
 * the indicator blank while those writes were still landing.
 *
 * What deliberately does *not* carry over is a *finished* run: the page keeps the indicator unmounted
 * until it has something to report about the current visit, since these customizations are
 * customer-wide and a `Saved at` from an earlier visit would speak for rows a colleague may have
 * edited since.
 *
 * One page, one grid, one queue: nothing here needs a second instance.
 */
export const [instrumentUpdateQueueState$, instrumentUpdateQueue] = makeTaskQueueWithAtom();
